import {
  HEADER_HEIGHT_MD_LG_XL,
  HEADER_HEIGHT_XS_SM,
} from '@/styles/theme/constants';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'HeroLeadForm',
})(({ brandColors, spacing, breakpoints, typography, aspectRatio }) => ({
  container: {
    background: `linear-gradient(180deg, ${brandColors.chargeBlue} 0%, ${brandColors.offWhite} 100%)`,
  },
  textContentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  eyebrown: {
    color: brandColors.mediumBlue,
    textTransform: 'unset',
    margin: 0,
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  headline: {
    margin: `${spacing(1)} 0`,
  },
  subheading: {
    color: brandColors.mediumBlue,
  },
  eyebrowWithStars: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: spacing(1),
    [breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  stars: {
    display: 'flex',
    flexDirection: 'row',
    gap: spacing(0.5),
  },
  imagesContainer: {
    display: 'flex',
    gap: spacing(2),
    width: '100%',
    marginTop: spacing(3),
  },
  image: {
    flex: '1 1 0%',
    objectFit: 'cover',
    width: '100%',
    minWidth: 0,
    aspectRatio: aspectRatio['1/1'],
    maxWidth: typography.pxToRem(67.5),
    [breakpoints.up('sm')]: {
      maxWidth: typography.pxToRem(164.5),
    },
    [breakpoints.up('md')]: {
      maxWidth: typography.pxToRem(121),
    },
    [breakpoints.up('lg')]: {
      maxWidth: typography.pxToRem(133),
    },
    [breakpoints.up('xl')]: {
      maxWidth: typography.pxToRem(180),
    },
  },
  leadFormContainer: {
    marginTop: spacing(4),
    display: 'flex',
    justifyContent: 'flex-end',
    [breakpoints.up('md')]: {
      marginTop: 0,
    },
  },
  leadForm: {
    width: '100%',
    [breakpoints.up('md')]: {
      width: typography.pxToRem(457),
    },
    [breakpoints.up('lg')]: {
      width: typography.pxToRem(533),
    },
    [breakpoints.up('xl')]: {
      width: typography.pxToRem(600),
    },
  },
  immersive: {
    marginTop: typography.pxToRem(HEADER_HEIGHT_XS_SM),
    [breakpoints.up('md')]: {
      marginTop: typography.pxToRem(HEADER_HEIGHT_MD_LG_XL),
    },
  },
}));

export default useStyles;
